import { resolveScreenLayout } from "feat/layout/screen-layout";
import type { TabId } from "feat/layout/tab-bar/tabs";
import { pathnameOf } from "routing/route";
import { useSplitStore } from "./split.store";

/**
 * The pane tab whose trailing split column `path` opens in, while the tabs are splits: an entry
 * of the tab's list, such as a chat room or a team member's profile. The registry presents some
 * of these as sheets, which is right for one column; in two they belong beside the list, as on
 * web and Android. Undefined for every other route, or while the tabs are not splits.
 */
export function splitEntryTab(path: string): TabId | undefined {
  return useSplitStore.getState().tabsAreSplits ? paneEntryTab(path) : undefined;
}

/** The pane tab `path` is an entry of the list of, whether or not the tabs are splits now. */
export function paneEntryTab(path: string): TabId | undefined {
  const layout = resolveScreenLayout({
    width: 0,
    pathname: pathnameOf(path),
    twoPaneSetting: true,
    iosNativeNavigation: true,
    splitCollapsed: false,
  });
  if (layout.layout !== "two-pane" || layout.sheet || layout.leadingShowsRoute) return undefined;
  if (layout.trailingPane !== "route" || !layout.leadingPane || layout.leadingPane === "edit") return undefined;
  return layout.leadingPane;
}
